import React from 'react'
import MenuPages from './MenuPages'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const HeaderPages = () => {

    const addPagesPermission = checkPermission(
        permissionsConfig.addHeaderPage.role,
        permissionsConfig.addHeaderPage.action,
        permissionsConfig.addHeaderPage.type
        );

    const editPagesPermission = checkPermission(
        permissionsConfig.editHeaderPages.role,
        permissionsConfig.editHeaderPages.action,
        permissionsConfig.editHeaderPages.type
    );
        
    const deletePagesPermission = checkPermission(
        permissionsConfig.deleteHeaderPages.role,
        permissionsConfig.deleteHeaderPages.action,
        permissionsConfig.deleteHeaderPages.type
    );
    
    return (
        <MenuPages title="Header Pages" type="1" pageFrom="header-pages" addPagesPermission={addPagesPermission} editPagesPermission={editPagesPermission} deletePagesPermission={deletePagesPermission}></MenuPages>
    )
}

export default HeaderPages